export default __webpack_public_path__ + "static/media/load.deba3807.webp";